(() => {
  if (customElements.get("g2g-variant-discounts")) return;

  class VariantDiscounts extends HTMLElement {
    constructor() {
      super();
      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      this.frame = null;
    }

    connectedCallback() {
      this.picker = this.closest("product-variants");
      this.form = document.getElementById(this.picker?.getAttribute("form-id"));
      const data = this.querySelector('script[type="application/json"]');
      if (!this.picker || !this.form || !data) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch {
        return;
      }
      if (!Array.isArray(this.variants)) return;

      this.picker.addEventListener("change", this.scheduleUpdate);
      this.form.addEventListener("variant:changed", this.scheduleUpdate);
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.picker?.removeEventListener("change", this.scheduleUpdate);
      this.form?.removeEventListener("variant:changed", this.scheduleUpdate);
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateDiscounts();
      });
    }

    updateDiscounts() {
      const selectedOptions = [];
      this.picker
        .querySelectorAll('input[name^="option"]:checked, select[name^="option"]')
        .forEach((input) => {
          const position = Number(input.name.slice(6)) - 1;
          selectedOptions[position] = input.value;
        });

      this.picker.querySelectorAll("[data-variant-discount-option]").forEach((swatch) => {
        const position = Number(swatch.dataset.variantDiscountOption);
        const options = selectedOptions.slice();
        options[position] = swatch.dataset.variantDiscountValue;
        const exactVariant = this.variants.find((candidate) =>
          candidate.options.every((value, index) => value === options[index]),
        );
        const variant = exactVariant || this.variants.find((candidate) =>
          candidate.available && candidate.options[position] === options[position],
        );
        const percentage = variant?.available && variant.compare_at_price > 0 &&
          variant.compare_at_price > variant.price
          ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)
          : 0;
        const badge = swatch.querySelector("[data-variant-discount-badge]");
        const description = swatch.querySelector("[data-variant-discount-description]");
        const input = swatch.querySelector('input[name^="option"]');
        if (!badge || !description || !input) return;

        badge.hidden = percentage <= 0;
        description.hidden = percentage <= 0;
        badge.textContent = `-${percentage}%`;
        description.textContent = this.dataset.discountLabel.replace("__savings__", `${percentage}%`);
        if (percentage > 0) {
          input.setAttribute("aria-describedby", description.id);
        } else {
          input.removeAttribute("aria-describedby");
        }
      });
    }
  }

  customElements.define("g2g-variant-discounts", VariantDiscounts);
})();
